<template>
    <TotemSelect
        :options="levelOptions"
        :placeholder="$t('CourseListFilter.skill_level')"
        @input="selectLevel"
        class="filter-select"
        ref="selectLevel"
        :isFilter="true"
        :reduce="option => String(option.level)"
        :value="selectedLevel"
    />
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'CompletedLevelFilter',
        props: {
            entityList: Array
        },
        computed: {
            ...mapGetters({
                selectedLevel: 'CourseFilter/getSelectedLevel',
            }),
            levelOptions () {
                const levelsInCertificates = this.entityList.reduce((levels, entity) => {
                    switch (entity.entityType ?? 'course') {
                    case 'learningPath':
                        levels.push(...entity.certificate.levels)
                        break
                    case 'course':
                        levels.push(entity.certificate.level)
                    }
                    return levels
                }, [])
                const uniqueLevels = [...new Set(levelsInCertificates)].sort()
                return uniqueLevels.map(level => {
                    const label = this.$t(`Select.skill_level_${level}`)
                    return { label, level }
                })
            },
        },
        methods: {
            filterByLevel (data) {
                if (this.selectedLevel === null) {
                    return data
                }
                const selectedLevel = Number(this.selectedLevel)

                return data.filter(({ certificate: entityCertificate }) => {
                    if (entityCertificate.levels) {
                        return entityCertificate.levels.includes(selectedLevel)
                    }
                    return entityCertificate.level === selectedLevel
                })
            },
            selectLevel (option) {
                this.$store.dispatch('CourseFilter/selectLevel', option)
            },
            clear () {
                this.$refs.selectLevel.clear()
            }
        }
    }
</script>
